import React from 'react';

function ServicesStatus({ services }) {
  const entries = services && typeof services === 'object' ? Object.entries(services) : [];

  return (
    <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16, marginBottom: 24 }}>
      <h3 style={{ color: '#e5e7eb', marginTop: 0, marginBottom: 16, fontSize: 18 }}>Services</h3>
      {entries.length === 0 ? (
        <p style={{ color: '#9ca3af', margin: 0 }}>No service status data available.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
          {entries.map(([service, raw]) => {
            const status = (raw && typeof raw === 'object') ? String(raw.status || '') : String(raw || '');
            const message = (raw && typeof raw === 'object') ? String(raw.message || raw.error || '') : '';
            const s = status.toLowerCase();
            const level = s === 'healthy' || s === 'running' || s === 'ok'
              ? 'running'
              : s === 'degraded' || s === 'stopped'
                ? 'stopped'
                : s === 'skipped'
                  ? 'stopped'
                  : 'error';
            const bg = level === 'running' ? 'rgba(16, 185, 129, 0.1)' : level === 'stopped' ? 'rgba(245, 158, 11, 0.1)' : 'rgba(239, 68, 68, 0.1)';
            const border = level === 'running' ? 'rgba(16, 185, 129, 0.3)' : level === 'stopped' ? 'rgba(245, 158, 11, 0.3)' : 'rgba(239, 68, 68, 0.3)';
            const dot = level === 'running' ? '#10b981' : level === 'stopped' ? '#f59e0b' : '#ef4444';

            return (
              <div key={service} style={{ background: bg, border: `1px solid ${border}`, borderRadius: 8, padding: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <div style={{ width: 10, height: 10, borderRadius: '50%', background: dot, marginRight: 8 }} />
                  <span style={{ color: '#e5e7eb', fontWeight: 500, textTransform: 'capitalize' }}>{service}</span>
                </div>
                <div style={{ color: dot, fontSize: 12, textTransform: 'capitalize' }}>{status || level}</div>
                {message ? (
                  <div style={{ color: '#9ca3af', fontSize: 12, marginTop: 6, lineHeight: 1.3 }}>{message}</div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default React.memo(ServicesStatus);
